export default __webpack_public_path__ + "7752c986a63ba90a806684e74ceff9ba.svg";